import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import Axios from "axios";
import Table from "react-bootstrap/Table";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import "./wrongsticker.css";

function Wrongsticker() {
  const [data, setData] = useState([]);
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [batchIds, setBatchIds] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [addedValues, setAddedValues] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getOrder`)
      .then((response) => {
        setData(response.data);
        const uniqueBatchIds = [
          ...new Set(
            response.data.flatMap((order) =>
              order.updatedQuantity.map((item) => item.batchid)
            )
          ),
        ];
        setBatchIds(uniqueBatchIds);
      })
      .catch((error) => {
        console.error("Error fetching order data:", error);
      });
  }, []);

  const filteredData = selectedBatchId
    ? data.filter((order) =>
        order.updatedQuantity.some((item) => item.batchid === selectedBatchId)
      )
    : [];





  const handleAddValue = async () => {
    if (inputValue.trim() === "") return;

    try {
      const response = await Axios.post(
        `${INVENTORY_API_BASE_URL}/update-values`,
        {
          scannedValue: inputValue, 
        }
      );

      if (response.data.valid) {
        if (addedValues.length >= 100) {
          alert("⚠️ You cannot add more than 100 values!");
          return;
        }

        if (addedValues.includes(inputValue)) {
          alert("⚠️ This value has already been scanned!");
        } else {
          setAddedValues((prevValues) => [...prevValues, inputValue]);
          setSuccessMessage("✅ Scan Successful!");

          setTimeout(() => {
            setSuccessMessage("");
          }, 1000);
        }
      } else {
        alert(`❌ Invalid scanned value: ${inputValue}`);
      }
    } catch (error) {
      console.error("Error validating scanned value:", error);
      alert("❌ Error validating the scanned value. Please try again.");
    } finally {
      setInputValue("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddValue();
    }
  };

  const handleSubmit = async () => {
    if (!selectedBatchId) {
      alert("⚠️ Please select a Batch ID before submitting.");
      return;
    }
    if (addedValues.length === 0) {
      alert("⚠️ Please scan or enter values to submit.");
      return;
    }

    setLoading(true);
    try {
      const response = await Axios.post(
        `${INVENTORY_API_BASE_URL}/update-values`,
        {
          valuesToUpdate: addedValues,
        }
      );

      if (response.data?.message) {
        alert(`✅ ${response.data.message}`);
      } else {
        alert("✅ Values updated successfully.");
      }

      setAddedValues([]);
    } catch (error) {
      console.error(error);
      alert("❌ Incorrect Scanned values.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="wrongsticker-container">
      <div className="wrongsticker-workspace">
        <header className="wrongsticker-hero">
          <div>
            <p className="wrongsticker-eyebrow">Inventory / Sticker correction</p>
            <h1>Wrong sticker scan</h1>
            <p>
              Select a batch, validate sticker values, and submit the accepted scans for cancellation.
            </p>
          </div>
          <div className="wrongsticker-hero-badge">
            <span className="wrongsticker-hero-icon" aria-hidden="true">QC</span>
            <span>
              <strong>Barcode validation</strong>
              <small>Batch-based review</small>
            </span>
          </div>
        </header>

        <section className="wrongsticker-metrics" aria-label="Sticker scan summary">
          <article className="wrongsticker-metric">
            <span className="wrongsticker-metric-icon" aria-hidden="true">BCH</span>
            <span className="wrongsticker-metric-copy">
              <span>Available batches</span>
              <strong>{batchIds.length.toLocaleString()}</strong>
            </span>
          </article>
          <article className="wrongsticker-metric wrongsticker-metric--batch">
            <span className="wrongsticker-metric-icon" aria-hidden="true">ID</span>
            <span className="wrongsticker-metric-copy">
              <span>Selected batch</span>
              <strong className="wrongsticker-metric-value">{selectedBatchId || "—"}</strong>
            </span>
          </article>
          <article className="wrongsticker-metric wrongsticker-metric--scanned">
            <span className="wrongsticker-metric-icon" aria-hidden="true">SCN</span>
            <span className="wrongsticker-metric-copy">
              <span>Scanned values</span>
              <strong>{addedValues.length} <small>/ 100</small></strong>
            </span>
          </article>
        </section>

        <section className="wrongsticker-panel wrongsticker-batch-panel" aria-labelledby="wrongsticker-batch-heading">
          <div className="wrongsticker-panel-heading">
            <div>
              <p className="wrongsticker-section-eyebrow">Step 1 · Batch selection</p>
              <h2 id="wrongsticker-batch-heading">Choose a batch to review</h2>
              <p>Search by batch ID or book title to load the matching order items.</p>
            </div>
            <span className="wrongsticker-panel-tag">Required</span>
          </div>
          <div className="wrongsticker-batch-select">
            <label htmlFor="wrongsticker-batch-select">Batch ID</label>
            <Select
              inputId="wrongsticker-batch-select"
              className="wrongsticker-select"
              classNamePrefix="wrongsticker-select"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              menuPlacement="auto"
              options={batchIds.map((batchId) => {
                const order = data.find((order) =>
                  order.updatedQuantity.some((item) => item.batchid === batchId)
                );
                const title = order
                  ? order.updatedQuantity.find((item) => item.batchid === batchId).title
                  : "";
                return { value: batchId, label: batchId + " - " + title };
              })}
              onChange={(selectedOption) =>
                setSelectedBatchId(selectedOption ? selectedOption.value : "")
              }
              placeholder="Select or search batch ID"
              isClearable
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: "42px",
                  fontSize: "0.88rem",
                }),
                menu: (provided) => ({ ...provided, zIndex: 10000 }),
                menuPortal: (provided) => ({ ...provided, zIndex: 10000 }),
              }}
            />
            <small>Choose a batch before scanning sticker values.</small>
          </div>
        </section>

        {selectedBatchId ? (
          <>
            <section className="wrongsticker-panel wrongsticker-items-panel" aria-labelledby="wrongsticker-items-heading">
              <div className="wrongsticker-panel-heading">
                <div>
                  <p className="wrongsticker-section-eyebrow">Step 2 · Batch contents</p>
                  <h2 id="wrongsticker-items-heading">Items in this batch</h2>
                  <p>Confirm the book and edition before entering sticker values.</p>
                </div>
                <span className="wrongsticker-panel-tag">
                  {filteredData.length} {filteredData.length === 1 ? "ORDER" : "ORDERS"}
                </span>
              </div>
              <div className="wrongsticker-table-wrap">
                <Table className="wrongsticker-table">
                  <thead>
                    <tr>
                      <th scope="col">Batch ID</th>
                      <th scope="col">SKU</th>
                      <th scope="col">Title</th>
                      <th scope="col">Medium</th>
                      <th scope="col">Edition</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((order, orderIndex) =>
                        order.updatedQuantity
                          .filter((item) => item.batchid === selectedBatchId)
                          .map((item, itemIndex) => (
                            <tr key={(order._id || orderIndex) + "-" + itemIndex}>
                              <td data-label="Batch ID">
                                <span className="wrongsticker-batch-id">{item.batchid}</span>
                              </td>
                              <td data-label="SKU">{item.sku}</td>
                              <td data-label="Title" className="wrongsticker-title-cell">{item.title}</td>
                              <td data-label="Medium">{item.Medium}</td>
                              <td data-label="Edition">{item.edition}</td>
                            </tr>
                          ))
                      )
                    ) : (
                      <tr>
                        <td className="wrongsticker-empty-cell" colSpan={5}>
                          <div className="wrongsticker-empty">
                            <strong>No order items found for this batch</strong>
                            <span>Select another batch to view its matching items.</span>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </section>

            <section className="wrongsticker-panel wrongsticker-scan-panel" aria-labelledby="wrongsticker-scan-heading">
              <div className="wrongsticker-panel-heading">
                <div>
                  <p className="wrongsticker-section-eyebrow">Step 3 · Sticker validation</p>
                  <h2 id="wrongsticker-scan-heading">Scan or enter sticker values</h2>
                  <p>Scan a barcode or type its value, then add it to the submission list.</p>
                </div>
                <span className="wrongsticker-panel-tag wrongsticker-panel-tag--limit">Up to 100 values</span>
              </div>

              <div className="wrongsticker-scan-entry">
                <label htmlFor="wrongsticker-value-input">Sticker value</label>
                <div className="wrongsticker-input-row">
                  <Form.Control
                    id="wrongsticker-value-input"
                    className="wrongsticker-input"
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="Scan barcode or enter value"
                    autoComplete="off"
                  />
                  <Button className="wrongsticker-add-button" type="button" onClick={handleAddValue}>
                    Add value
                    <span aria-hidden="true">+</span>
                  </Button>
                </div>
                <small>Press Enter or select Add value to validate the scan.</small>
              </div>

              {addedValues.length > 0 && (
                <div className="wrongsticker-scanned-panel">
                  <div className="wrongsticker-scanned-heading">
                    <div>
                      <h3>Scanned values</h3>
                      <p>Values queued for submission</p>
                    </div>
                    <span>{addedValues.length} / 100</span>
                  </div>
                  <div className="wrongsticker-scanned-list">
                    <Table className="wrongsticker-scanned-table" size="sm">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Scanned value</th>
                        </tr>
                      </thead>
                      <tbody>
                        {addedValues.map((value, index) => (
                          <tr key={index}>
                            <td data-label="Number">{index + 1}</td>
                            <td data-label="Scanned value">
                              <span className="wrongsticker-scan-code">{value}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              )}

              {successMessage && (
                <Alert className="wrongsticker-success" variant="success" role="status">
                  {successMessage}
                </Alert>
              )}

              <footer className="wrongsticker-submit-row">
                <p>
                  {addedValues.length > 0
                    ? addedValues.length + " validated " + (addedValues.length === 1 ? "value" : "values") + " ready to submit."
                    : "Add at least one valid sticker value to enable submission."}
                </p>
                <Button
                  className="wrongsticker-submit-button"
                  variant="success"
                  type="button"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit values"}
                  {!loading && <span aria-hidden="true">→</span>}
                </Button>
              </footer>
            </section>
          </>
        ) : (
          <section className="wrongsticker-panel wrongsticker-empty-panel" aria-label="Select a batch">
            <div className="wrongsticker-empty">
              <span className="wrongsticker-empty-icon" aria-hidden="true">BCH</span>
              <strong>Select a batch to continue</strong>
              <span>Batch items and the sticker scanning form will appear here after selection.</span>
            </div>
          </section>
        )}
      </div>
    </main>
  );
}

export default Wrongsticker;
